"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.personalEditorialCategoryPageFragment = void 0;
var _fetching = require("@ori/fetching");
var _editorialPageFragment = require("./editorialPageFragment");
const personalEditorialCategoryFragment = (0, _fetching.gql)`
  fragment PersonalEditorialCategory on PersonalEditorialLandingPage {
    landingPageId
    imageUrl
    thumbnailUrl
    description
    themeTag
    link {
      relativeUrl
    }
  }
`;
const personalEditorialCategoryPageFragment = exports.personalEditorialCategoryPageFragment = (0, _fetching.gql)`
  ${personalEditorialCategoryFragment}
  ${_editorialPageFragment.editorialPageFragment}
  fragment PersonalEditorialCategoryPage on Application {
    personalEditorialLandingPage(landingPageId: $pageId) {
      landingPageId
      imageUrl
      thumbnailUrl
      description
      themeTag
      editorialItems {
        ...EditorialPage
      }
      backgroundStorybookColor
      headlineStorybookColor
      themeItems @include(if: $includeThemeItems) {
        ...PersonalEditorialCategory
      }
    }
    rootPersonalEditorialLandingPage: personalEditorialLandingPage(landingPageId: $landingPageId)
      @include(if: $includeRoot) {
      themeItems {
        ...PersonalEditorialCategory
      }
    }
  }
`;
